import { render, staticRenderFns } from "./PowerDialog.vue?vue&type=template&id=3a8080cc&scoped=true"
import script from "./PowerDialog.vue?vue&type=script&lang=js"
export * from "./PowerDialog.vue?vue&type=script&lang=js"
import style0 from "./PowerDialog.vue?vue&type=style&index=0&id=3a8080cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8080cc",
  null
  
)

export default component.exports